import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";
import { AuthProvider } from "@/context/AuthContext";
import { lenisRef } from "@/scroll";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Pillars from "@/components/Pillars";
import Banner from "@/components/Banner";
import Events from "@/components/Events";
import MediaMarquee from "@/components/MediaMarquee";
import JoinForm from "@/components/JoinForm";
import PhotoStrip from "@/components/PhotoStrip";
import Footer from "@/components/Footer";
import AuthModal from "@/components/AuthModal";
import AdminPage from "@/pages/AdminPage";
import MemberPage from "@/pages/MemberPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import EventPage from "@/pages/EventPage";
import CheckinScanPage from "@/pages/CheckinScanPage";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="bg-ink text-bone min-h-screen">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/profilo" element={<MemberPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/eventi/:id" element={<EventPage />} />
              <Route path="/checkin/:token" element={<CheckinScanPage />} />
            </Routes>
            <AuthModal />
            <Toaster position="bottom-right" theme="dark" />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

function Home() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Pillars />
        <Banner />
        <Events />
        <MediaMarquee />
        <JoinForm />
        <PhotoStrip />
      </main>
      <Footer />
    </>
  );
}
